module.exports = __webpack_public_path__ + "static/media/8.61ec4f73.jpg";